<template>
  <div class="servicos">
		<section>
			<div class="container">
				<div class="row">
					
					<grupo-categoria @filterCategoria="filterCategoria"></grupo-categoria>
					<div class="col-sm-9 padding-right">
						<div class="features_items"><!--features_items-->
							<h2 class="title text-center">PRODUTOS</h2>
							<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item"><a @click="filter = ''">Todos</a></li>
								<li class="breadcrumb-item active" aria-current="page" v-show="filter">{{categoriaName}}</li>
							</ol>
							</nav>
							<div class="col-sm-4" v-for="p in servicosFiltered">
								<a @click="$router.push({ name: 'DetalhesProduto', params: { id: p.id }})">
								<div class="product-image-wrapper">
									<div class="single-products">
										<div class="productinfo text-center">
											<img v-if="p.imagens" :src="p.imagens[0]" alt="" class="imgProduct"/>
											<!--<h2 class="whitoutTopMargin">$$$</h2>-->
											<p class="nameService">{{p.nome}}</p>
											<a class="btn btn-default add-to-cart" @click="$router.push({ name: 'DetalhesProduto', params: { id: p.id }})"><i class="fa fa-eye"></i>Ver Produto</a>
										</div>
										<!-- <div class="product-overlay">
											<div class="overlay-content">
												<h2>$56</h2>
												<p>Easy Polo Black Edition</p>
												<a href="#" class="btn btn-default add-to-cart"><i class="fa fa-eye"></i>Ver Produto</a>
											</div>
										</div> -->
									</div>
								</div>
								</a>
							</div>
						</div><!--features_items-->
					</div>
				</div>
			</div>
		</section>
  </div>
</template>
<script>
import firebase from 'firebase';
import GrupoCategoria from '../components/CategoriasProdutos.vue';
import _ from 'lodash';
import $ from 'jquery';

export default {
	name: 'Servicos',
	components: {
		GrupoCategoria
	},
	data() {
		return {
			categorias: [],
			servicos: [],
			filter: '',
			searchText: ''
		}
	},
	created() {
		$("html, body").animate({ scrollTop: 0 }, "slow");
		this.searchText = this.$route.params.searchText ? this.$route.params.searchText : ''
		this.getCategoria();
		this.getServicos();
		if(this.$route.params.categoria) {
			console.log('params => ', this.$route.params.categoria)
			this.filter = this.$route.params.categoria
		}
	},
	methods: {
		getCategoria() {
			var cat = firebase.database().ref('categorias2/')
			cat.on('child_added', (data) => {
				this.categorias.push({ nome: data.val().nome, id: data.key})
			});
		},
		getServicos() {
			var cat = firebase.database().ref('produtos2/')
			cat.on('child_added', (data) => {
				this.servicos.push({ id: data.key, nome: data.val().nome, categoria: data.val().categoria, imagens: data.val().imagens, descricao: data.val().descricao })
			});
			console.log(this.servicos)
		},
		filterCategoria(categoria) {
			this.filter = categoria;
			this.searchText = ''
		}
	},
	computed: {
		servicosFiltered () {
			if(this.searchText) {
				return _.filter(this.servicos, item => {
					return item.nome.toUpperCase().indexOf(this.searchText.toUpperCase()) > -1
				})
			}
			if(this.filter) {
				return _.filter(this.servicos, item => {
					return item.categoria == this.filter
				})
			}
			return this.servicos
		},
		categoriaName() {
			let ret;
			this.categorias.forEach(element => {
				if(element.id == this.filter) {
					ret = element.nome
				}
			});
			return ret
		}
	}
}
</script>

<style>
.servicos {
  padding-top: 10px
}

a:hover {
	cursor: pointer;
}
.nameService {
	font-family: 'Open Sans', Arial, Helvetica, sans-serif!important;
    font-size: 14px!important;
    line-height: 25px!important;
    font-weight: 600!important;
	margin-top: 5%
}
</style>
